import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  tr: {
    translation: {
      // Header
      "features": "Özellikler",
      "integrations": "Entegrasyonlar",
      "models": "Modeller",
      "references": "Referanslar",
      "apply": "Başvuru Yap",
      "login": "Sisteme Giriş",
      
      // Hero
      "hero_title": "Teslimat Operasyonunuzu İleriye Taşıyın.",
      "hero_subtitle": "Kurye yönetimi, otomatik atama, entegrasyonlar ve güçlü raporlama tek platformda.",
      "hero_cta_apply": "Başvuru Yap",
      "hero_cta_login": "Sisteme Giriş",
      
      // Metrics
      "deliveries": "Teslimat",
      "couriers": "Kurye",
      "restaurants": "Restoran",
      "cities": "Şehir",
      
      // Features
      "features_title": "Güçlü Özellikler",
      "features_subtitle": "Teslimat operasyonunuzu optimize edin",
      "feature_auto_assign": "Otomatik Atama",
      "feature_auto_assign_desc": "Akıllı algoritma ile en yakın ve uygun kuryeye otomatik sipariş atama.",
      "feature_accounting": "Kurye Ön Muhasebe",
      "feature_accounting_desc": "Kurye kazançları, komisyonlar ve ödemeleri tek ekranda takip edin.",
      "feature_reporting": "Gelişmiş Raporlama",
      "feature_reporting_desc": "Detaylı analizler ve görsel raporlarla operasyonunuzu analiz edin.",
      "feature_restaurant_panel": "Kolay Restoran Paneli",
      "feature_restaurant_panel_desc": "Restoranlar için basit ve kullanışlı sipariş yönetim paneli.",
      "feature_live_tracking": "Canlı Takip",
      "feature_live_tracking_desc": "Siparişleri ve kuryeleri gerçek zamanlı harita üzerinde takip edin.",
      "feature_247": "7/24 Operasyon",
      "feature_247_desc": "Kesintisiz hizmet ile gece gündüz teslimat yönetimi.",
      
      // Integrations
      "integrations_title": "Entegrasyonlar",
      "integrations_subtitle": "Popüler platformlarla sorunsuz entegrasyon",
      
      // Models
      "models_title": "Çalışma Modelleri",
      "models_subtitle": "İhtiyacınıza uygun model seçin",
      "model_pool": "Havuz Modeli",
      "model_pool_desc": "Paket başı ödeme, sabit ücret yok. En yakın müsait kurye otomatik atanır.",
      "model_pool_feature1": "Paket başı ödeme",
      "model_pool_feature2": "Sabit ücret yok",
      "model_pool_feature3": "En yakın kurye ataması",
      "model_pool_feature4": "Esnek kullanım",
      "model_fixed": "Sabit Model",
      "model_fixed_desc": "Restorana özel kurye, sabit aylık ücret. Tam kontrol sizde.",
      "model_fixed_feature1": "Özel kurye ataması",
      "model_fixed_feature2": "Sabit aylık ücret",
      "model_fixed_feature3": "Öncelikli teslimat",
      "model_fixed_feature4": "Marka tutarlılığı",
      
      // Benefits
      "benefits_title": "Avantajlar",
      "benefits_subtitle": "Her kesim için özel çözümler",
      "tab_restaurant": "Restoranlar",
      "tab_courier": "Kuryeler",
      "tab_company": "Kurye Şirketleri",
      "tab_individual": "Bireysel",
      
      "benefit_restaurant_1": "Hızlı ve güvenilir teslimat",
      "benefit_restaurant_2": "Tek panelden tüm siparişleri yönetin",
      "benefit_restaurant_3": "Şeffaf raporlama",
      "benefit_restaurant_4": "Yasal, profesyonel kuryeler",
      "benefit_restaurant_5": "Canlı kurye takibi",
      
      "benefit_courier_1": "Yüksek kazanç potansiyeli",
      "benefit_courier_2": "Performans bonusları",
      "benefit_courier_3": "Esnek vardiya seçimi",
      "benefit_courier_4": "KM desteği",
      "benefit_courier_5": "Günlük ödeme imkanı",
      
      "benefit_company_1": "Otomatik sipariş atama",
      "benefit_company_2": "Mobil kurye uygulaması",
      "benefit_company_3": "Entegre muhasebe",
      "benefit_company_4": "Vardiya yönetimi",
      "benefit_company_5": "SMS/WhatsApp bildirimleri",
      
      "benefit_individual_1": "Yakında: Kurye çağırma",
      "benefit_individual_2": "Hızlı teslimat",
      "benefit_individual_3": "Canlı takip",
      "benefit_individual_4": "Güvenli ödeme",
      
      // References
      "references_title": "Referanslarımız",
      "references_subtitle": "Güvenilir iş ortaklarımız",
      
      // Application Forms
      "apply_title": "Başvuru",
      "apply_subtitle": "Bize katılın",
      "form_courier": "Kurye Başvurusu",
      "form_restaurant": "Restoran Başvurusu",
      "form_company": "Kurye Şirketi Başvurusu",
      
      // Courier Form
      "full_name": "Ad Soyad",
      "phone": "Telefon",
      "province": "İl",
      "district": "İlçe",
      "license_types": "Ehliyet Sınıfı",
      "has_motorcycle": "Motosikletiniz var mı?",
      "motorcycle_brand": "Motosiklet Marka ve Modeli",
      "motorcycle_model": "Motor Modeli",
      "daily_hours": "Günlük Çalışma Saati",
      "experience": "Varsa deneyimleriniz?",
      "description": "Kısaca Kendinizden Bahseder misiniz?",
      
      // Restaurant Form
      "restaurant_name": "Restoran Adı",
      "contact_name": "Yetkili Adı",
      "address": "Adres",
      "package_count": "Günlük Paket Sayısı",
      "has_courier": "Mevcut kuryeniz var mı?",
      "uses_other_service": "Başka kurye hizmeti kullanıyor musunuz?",
      
      // Company Form
      "has_active_company": "Aktif kurye şirketiniz var mı?",
      "application_type": "Başvuru Tipi",
      "franchise_software": "Bayilik + Yazılım",
      "software_only": "Sadece Yazılım",
      
      // Common
      "yes": "Evet",
      "no": "Hayır",
      "select": "Seçiniz",
      "submit": "Gönder",
      "submitting": "Gönderiliyor...",
      "success": "Başarılı",
      "error": "Hata",
      "required": "Zorunlu alan",
      "captcha_label": "Güvenlik Sorusu",
      "captcha_placeholder": "Cevabı girin",
      
      // Contact
      "contact_title": "İletişim",
      "contact_address": "Bahçelievler mh. 3034 sk. No:5 Isparta/Merkez",
      
      // Footer
      "footer_slogan": "İleriye Taşır...",
      "footer_rights": "Tüm hakları saklıdır.",
      
      // Time options
      "hours_4_6": "4-6 saat",
      "hours_6_10": "6-10 saat",
      "hours_10_12": "10-12 saat",
      "hours_12_plus": "12+ saat",
      
      // Success messages
      "application_success": "Başvurunuz başarıyla alındı!",
      "application_success_desc": "En kısa sürede sizinle iletişime geçeceğiz.",
      
      // Restaurant Audience
      "restaurant_hero_title": "Teslimatınızı Hızlandırın,\nMüşterilerinizi Mutlu Edin",
      "restaurant_hero_subtitle": "Profesyonel kurye ağımızla paketleriniz dakikalar içinde müşterinizin kapısında. Tek panel, sınırsız teslimat.",
      "restaurant_hero_cta": "Hemen Başvur",
      "restaurant_stat_partners": "Partner Restoran",
      "restaurant_stat_satisfaction": "Memnuniyet Oranı",
      "restaurant_stat_fee": "Sabit Ücret",
      "restaurant_feature1_title": "Tüm Siparişler Tek Ekranda",
      "restaurant_feature1_desc": "Yemeksepeti, Getir, Trendyol... Tüm platformlardan gelen siparişleri tek ekrandan yönetin.",
      "restaurant_feature2_title": "Hızlı Kurye Bulma",
      "restaurant_feature2_desc": "Siparişiniz hazır olduğunda en yakın müsait kuryeyi saniyeler içinde bulun.",
      "restaurant_feature3_title": "Canlı Kurye Takibi",
      "restaurant_feature3_desc": "Siparişlerinizin nerede olduğunu gerçek zamanlı harita üzerinde takip edin.",
      "restaurant_feature4_title": "Kolay Menü ve Sipariş Yönetimi",
      "restaurant_feature4_desc": "Menünüzü kolayca güncelleyin, siparişleri hızlıca onaylayın ve yönetin.",
      "restaurant_feature5_title": "Net ve Anlaşılır Raporlar",
      "restaurant_feature5_desc": "Günlük, haftalık, aylık teslimat raporlarınıza anında erişin.",
      "restaurant_feature6_title": "Esnek Ödeme Modeli",
      "restaurant_feature6_desc": "Sabit ücret yok! Sadece yaptığınız teslimat kadar ödeyin.",
      "restaurant_benefit1": "Yasal, profesyonel, kayıtlı kuryeler",
      "restaurant_benefit2": "Canlı müşteri bildirimleri",
      "restaurant_benefit3": "Kurulum ücreti yok, hemen başlayın",
      "restaurant_benefit4": "Marka imajınıza uygun teslimat",
      "restaurant_benefit5": "7/24 anında hızlı iletişim",
      
      // Courier Audience
      "courier_hero_title": "Kendi Saatlerini Belirle,\nKazancını Katlayarak Artır",
      "courier_hero_subtitle": "Türkiye'nin en çok kazandıran kurye platformu. Esnek vardiyalar, günlük ödemeler, performans bonusları.",
      "courier_hero_cta": "Kurye Ol",
      "courier_stat_daily": "Günlük Kazanç",
      "courier_stat_km": "KM Desteği",
      "courier_stat_bonus": "Bonus Fırsatları",
      "courier_stat_bonus_value": "Özel Gün",
      "courier_feature1_title": "Tüm Siparişler Tek Uygulamada",
      "courier_feature1_desc": "Farklı restoranlardan gelen tüm siparişleri tek uygulama üzerinden kolayca alın ve yönetin.",
      "courier_feature2_title": "Yüksek Kazanç",
      "courier_feature2_desc": "Bölgenin en yüksek paket başı ücretleri ve ekstra bonuslarla kazancınızı maksimize edin.",
      "courier_feature3_title": "Akıllı Rota",
      "courier_feature3_desc": "En kısa ve en hızlı teslimat rotası otomatik olarak belirlenir, zamandan tasarruf edin.",
      "courier_feature4_title": "Günlük Ödeme & Anlık Kazanç Takibi",
      "courier_feature4_desc": "Kazancınızı anlık takip edin, her gün hesabınızda görün. Haftalık veya aylık beklemeye son.",
      "courier_feature5_title": "Esnek Çalışma",
      "courier_feature5_desc": "Sabah, öğlen, akşam... İstediğiniz vardiyayı seçin, istediğiniz kadar çalışın.",
      "courier_feature6_title": "Basit ve Hızlı Kullanım",
      "courier_feature6_desc": "Karmaşık menüler yok. Siparişi al, teslim et, kazan. İşte bu kadar basit.",
      "courier_benefit1": "Performans bazlı bonus sistemi",
      "courier_benefit2": "KM başı yakıt desteği",
      "courier_benefit3": "JetPuanMarket'ten ücretsiz alışveriş",
      "courier_benefit4": "Profesyonel ekip ve sahada destek",
      "courier_benefit5": "Haftalık eğitim ve gelişim fırsatları",
      
      // Company Audience
      "company_hero_title": "Kurye Operasyonunuzu\nDijital Çağa Taşıyın",
      "company_hero_subtitle": "Türkiye'nin en gelişmiş kurye yönetim yazılımı. Otomatik atama, akıllı rotalama, entegre muhasebe.",
      "company_hero_cta": "Demo Talep Et",
      "company_stat_efficiency": "Verimlilik Artışı",
      "company_stat_assignment": "Daha Hızlı Atama",
      "company_stat_setup": "Kurulum Ücreti",
      "company_feature1_title": "Tüm Siparişler Tek Panelde",
      "company_feature1_desc": "Farklı kaynaklardan gelen tüm siparişleri tek bir panel üzerinden takip edin ve yönetin.",
      "company_feature2_title": "Otomatik Kurye Atama",
      "company_feature2_desc": "AI destekli algoritma ile en yakın ve uygun kuryeye otomatik sipariş atama.",
      "company_feature3_title": "Canlı Kurye Takibi",
      "company_feature3_desc": "Tüm kuryelerinizi gerçek zamanlı harita üzerinde izleyin, performanslarını analiz edin.",
      "company_feature4_title": "Akıllı Rota Optimizasyonu",
      "company_feature4_desc": "Trafik ve mesafe analizi ile en verimli teslimat rotalarını otomatik oluşturun.",
      "company_feature5_title": "Kolay Muhasebe ve Raporlama",
      "company_feature5_desc": "Hakediş, prim, kesinti ve detaylı operasyon raporları tek sistemde.",
      "company_feature6_title": "Kurye Performans Takibi",
      "company_feature6_desc": "Her kuryenin teslimat süresi, müşteri memnuniyeti ve verimliliğini detaylı metriklerle analiz edin.",
      "company_benefit1": "Sınırsız kurye ve sipariş",
      "company_benefit2": "Kolay kullanım mobil uygulama",
      "company_benefit3": "Sms ve whatsapp entegrasyonları",
      "company_benefit4": "Kolay kurye fatura yönetimi",
      "company_benefit5": "Kesintisiz hizmet garantisi",
      
      // General Audience
      "general_hero_title": "Teslimat Operasyonunuzu\nİleriye Taşıyın",
      "general_hero_subtitle": "Kurye yönetimi, otomatik atama, entegrasyonlar ve güçlü raporlama tek platformda.",
      "general_hero_cta": "Başvuru Yap",
      "general_stat_deliveries": "Teslimat",
      "general_stat_couriers": "Kurye",
      "general_stat_restaurants": "Restoran",
      "general_feature1_title": "Otomatik Atama",
      "general_feature1_desc": "Akıllı algoritma ile en yakın kuryeye otomatik sipariş atama.",
      "general_feature2_title": "Canlı Takip",
      "general_feature2_desc": "Siparişleri ve kuryeleri gerçek zamanlı harita üzerinde izleyin.",
      "general_feature3_title": "Gelişmiş Raporlama",
      "general_feature3_desc": "Detaylı analizler ve görsel raporlarla operasyonunuzu optimize edin.",
      "general_feature4_title": "7/24 Operasyon",
      "general_feature4_desc": "Kesintisiz hizmet ile gece gündüz teslimat yönetimi.",
      "general_benefit1": "Hızlı ve güvenilir teslimat",
      "general_benefit2": "Şeffaf raporlama",
      "general_benefit3": "Esnek ödeme modelleri",
      "general_benefit4": "Entegre sipariş yönetimi",
      "general_benefit5": "7/24 destek",
      
      // Section titles
      "why_agrosjet": "Neden AgrosJet?",
      "features_for_you": "Size özel tasarlanmış çözümlerle fark yaratın",
      "get_started": "Hemen Başlayın",
      "join_family": "AgrosJet ailesine katılın ve teslimat operasyonunuzu bir üst seviyeye taşıyın.",
      "your_benefits": "Avantajlar",
      "benefits_for_you": "Size Özel",
      "benefits_subtitle": "AgrosJet ile fark yaratan özelliklerden yararlanın ve operasyonunuzu bir üst seviyeye taşıyın.",
      "integrations_work": "Popüler Platformlarla Sorunsuz Çalışın",
      "references_trusted": "Güvenilir İş Ortaklarımız",
      "references_leading": "2 ilin önde gelen işletmeleri AgrosJet'i tercih ediyor",
      "active_location": "2 İlde Aktif",
      "system_login": "Sisteme Giriş",
      
      // Models Section
      "models_badge": "Çalışma Modelleri",
      "models_title": "Size Uygun Modeli Seçin",
      "models_subtitle": "İşletmenizin ihtiyaçlarına göre esnek çalışma modelleri",
      "model_pool_title": "Havuz Kurye",
      "model_pool_desc": "Ortak kurye havuzundan anlık atama",
      "model_pool_f1": "Yoğun saatlerde esneklik",
      "model_pool_f2": "Sabit maliyet yok",
      "model_pool_f3": "Talebe göre ölçekleme",
      "model_pool_f4": "Anında kurye erişimi",
      "model_pool_highlight": "Küçük ve orta işletmeler için ideal",
      "model_fixed_title": "Sabit Kurye",
      "model_fixed_desc": "Size özel atanmış kurye kadrosu",
      "model_fixed_f1": "Müşterilerinizi tanıyan kuryeler",
      "model_fixed_f2": "Tutarlı hizmet kalitesi",
      "model_fixed_f3": "Öncelikli teslimat",
      "model_fixed_f4": "Markanızı temsil eden ekip",
      "model_fixed_highlight": "Yüksek hacimli işletmeler için ideal",

      // Why AgrosJet Section
      "why_agros_title": "Neden",
      "why_agros_point1": "3 yılı aşkın sahada kesintisiz operasyon deneyimi",
      "why_agros_point2": "Kurye yönetiminde uçtan uca dijital çözüm",
      "why_agros_point3": "Türkiye genelinde büyüyen partner ağı",
      "why_agros_point4": "Sürekli güncellenen, gelişen teknoloji altyapısı",
      "why_agros_desc1": "AgrosJet, 3 yılı aşkın süredir sahada kesintisiz operasyon yürütmektedir. Biz yalnızca yazılım geliştiren bir teknoloji şirketi değiliz; her gün sahada operasyon yöneten bir ekibiz. Yazılımımız masa başında değil, gerçek teslimat süreçlerinin içinden doğdu.",
      "why_agros_desc2": "Bu nedenle sunduğumuz her özellik, sizin operasyonel ihtiyaçlarınızın birebir yansımasıdır. Operasyonel güvenilirlik, hız ve müşteri memnuniyetinde sektörün en iddialı çözümünü sunuyoruz.",

      // Pricing Section
      "pricing_badge": "Ücretlendirme",
      "pricing_title": "Size Uygun Planı Seçin",
      "pricing_subtitle": "Operasyon hacminize göre esnek ücretlendirme seçenekleri",
      "pricing_popular": "Popüler",
      "pricing_starter_name": "Kontör",
      "pricing_starter_subtitle": "Paket başı ücretlendirme",
      "pricing_starter_price": "Paket Başı",
      "pricing_starter_note": "Hacim arttıkça birim fiyat düşer",
      "pricing_starter_f1": "Paket başı sabit ücret",
      "pricing_starter_f2": "Yüksek hacimde indirimli fiyat",
      "pricing_starter_f3": "Kurulum ücreti yok",
      "pricing_starter_f4": "Temel raporlama",
      "pricing_starter_f5": "E-posta destek",
      "pricing_starter_cta": "Teklif Al",
      "pricing_pro_name": "Sabit",
      "pricing_pro_subtitle": "Aylık sabit ücretlendirme",
      "pricing_pro_price": "Aylık Sabit",
      "pricing_pro_note": "Sınırsız paket, öngörülebilir bütçe",
      "pricing_pro_f1": "Sınırsız paket hakkı",
      "pricing_pro_f2": "Gelişmiş raporlama ve analitik",
      "pricing_pro_f3": "Öncelikli teknik destek",
      "pricing_pro_f4": "Entegrasyon desteği",
      "pricing_pro_f5": "Özel müşteri temsilcisi",
      "pricing_pro_cta": "Teklif Al",
      "pricing_franchise_name": "Bayilik",
      "pricing_franchise_subtitle": "AgrosJet bayisi olun",
      "pricing_franchise_price": "Özel Teklif",
      "pricing_franchise_note": "İşletmenize özel fiyatlandırma",
      "pricing_franchise_f1": "Tüm yazılım özellikleri",
      "pricing_franchise_f2": "Bölgesel münhasırlık",
      "pricing_franchise_f3": "Marka ve operasyon desteği",
      "pricing_franchise_f4": "Eğitim ve danışmanlık",
      "pricing_franchise_f5": "Gelir paylaşım modeli",
      "pricing_franchise_cta": "Özel Teklif Alın",

      // === Landing v2 (Unified Neon) ===
      "v2_nav_features": "Özellikler",
      "v2_nav_integrations": "Entegrasyonlar",
      "v2_nav_references": "Referanslar",
      "v2_nav_contact": "İletişim",
      "v2_apply_dropdown": "Başvurular",
      "v2_apply_courier": "Kurye Başvurusu",
      "v2_apply_restaurant": "Restoran Başvurusu",
      "v2_apply_company": "Kurye Şirketi Başvurusu",
      "v2_hero_badge": "AgrosJet · Teslimat Operasyon Platformu",
      "v2_hero_title_line1": "Teslimatın",
      "v2_hero_title_line2": "Geleceğini",
      "v2_hero_title_line3": "Bugün İnşa Et.",
      "v2_hero_sub": "Restoranlar, kuryeler ve kurye şirketleri için uçtan uca tek bir platform. Otomatik atama, akıllı rota, haftalık ödeme ve gerçek zamanlı analitik — hepsi bir arada.",
      "v2_hero_cta": "Başvurular",
      "v2_hero_scroll": "Aşağı kaydır",
      "v2_audience_title": "Sen kimsin? Tek tıkla başla.",
      "v2_audience_sub": "Hangi tarafta olursan ol, AgrosJet seninle çalışmak için hazır.",
      "v2_audience_restaurant_title": "Restoranım",
      "v2_audience_restaurant_desc": "Tüm platform siparişlerini tek panelde topla, profesyonel kuryelerle dakikalar içinde teslim et.",
      "v2_audience_restaurant_cta": "Restoran Başvurusu",
      "v2_audience_courier_title": "Kuryeyim",
      "v2_audience_courier_desc": "Esnek vardiyalarla çalış, haftalık ödeme al. Akıllı rota ve performans bonuslarıyla kazancını katla.",
      "v2_audience_courier_cta": "Kurye Başvurusu",
      "v2_audience_company_title": "Kurye Şirketiyim",
      "v2_audience_company_desc": "Operasyonunu dijitalleştir. Otomatik atama, canlı takip, entegre muhasebe ve sınırsız ölçeklenme.",
      "v2_audience_company_cta": "Şirket Başvurusu",
      "v2_stats_title": "Rakamlarla AgrosJet",
      "v2_stats_deliveries": "Toplam Teslimat",
      "v2_stats_couriers": "Aktif Kurye",
      "v2_stats_restaurants": "Partner Restoran",
      "v2_stats_years": "Yıl Saha Deneyimi",
      "v2_features_badge": "Platform Özellikleri",
      "v2_features_title": "Tek platform.",
      "v2_features_title_accent": "Sonsuz olasılık.",
      "v2_features_sub": "Operasyonun her aşaması için tasarlanmış güçlü modüller.",
      "v2_feature1_title": "Otomatik Atama",
      "v2_feature1_desc": "AI destekli algoritma siparişi en yakın, en uygun kuryeye saniyeler içinde atar.",
      "v2_feature2_title": "Canlı Harita Takibi",
      "v2_feature2_desc": "Tüm kuryeleri ve siparişleri gerçek zamanlı izle, müşterine canlı bildirim gönder.",
      "v2_feature3_title": "Akıllı Rota",
      "v2_feature3_desc": "Trafik ve mesafe analiziyle en hızlı teslimat rotası otomatik oluşturulur.",
      "v2_feature4_title": "Haftalık Ödeme",
      "v2_feature4_desc": "Kuryeler için haftalık düzenli ödeme; ödeme talebi sonrası 30 dakikada hesaba geçer.",
      "v2_feature5_title": "Tek Panel",
      "v2_feature5_desc": "Yemeksepeti, Getir, Trendyol ve diğer platformlardan gelen siparişler tek ekranda.",
      "v2_feature6_title": "Performans Analitiği",
      "v2_feature6_desc": "Kurye süresi, müşteri memnuniyeti, sipariş hacmi — her metrik görsel raporlarla.",
      "v2_feature7_title": "API & Entegrasyon",
      "v2_feature7_desc": "Mevcut sistemlerinle sorunsuz çalışan açık API ve hazır entegrasyonlar.",
      "v2_feature8_title": "7/24 Operasyon",
      "v2_feature8_desc": "Saha ekibimiz ve teknik destek her gün, her saat yanında.",
      "v2_why_badge": "Neden AgrosJet?",
      "v2_why_title": "Masa başında değil,",
      "v2_why_title_accent": "sahada doğdu.",
      "v2_why_desc1": "AgrosJet, 3 yılı aşkın süredir sahada kesintisiz operasyon yürüten bir ekip tarafından geliştirildi. Yazılımımız her gün gerçek kuryeler, gerçek restoranlar ve gerçek müşterilerle test edildi.",
      "v2_why_desc2": "Bu yüzden sunduğumuz her özellik, sektörün gerçek ihtiyaçlarının cevabıdır. Tahmin değil, deneyim.",
      "v2_why_point1": "3+ yıl kesintisiz saha operasyonu",
      "v2_why_point2": "Uçtan uca dijital kurye yönetimi",
      "v2_why_point3": "Türkiye genelinde büyüyen partner ağı",
      "v2_why_point4": "Sürekli güncellenen teknoloji altyapısı",
      "v2_cta_title": "Hazır mısın?",
      "v2_cta_title_accent": "Bir adım at, AgrosJet seni ileriye taşısın.",
      "v2_cta_sub": "İhtiyacına uygun başvuru formunu seç, ekibimiz 24 saat içinde dönsün.",
      "v2_cta_button": "Başvurular",
      "v2_footer_tagline": "Teslimat operasyonunu ileriye taşır."
    }
  },
  en: {
    translation: {
      // Header
      "features": "Features",
      "integrations": "Integrations",
      "models": "Models",
      "references": "References",
      "apply": "Apply",
      "login": "Login",
      
      // Hero
      "hero_title": "Advance Your Delivery Operations.",
      "hero_subtitle": "Courier management, auto-assignment, integrations, and powerful reporting in one platform.",
      "hero_cta_apply": "Apply Now",
      "hero_cta_login": "Login",
      
      // Metrics
      "deliveries": "Deliveries",
      "couriers": "Couriers",
      "restaurants": "Restaurants",
      "cities": "Cities",
      
      // Features
      "features_title": "Powerful Features",
      "features_subtitle": "Optimize your delivery operations",
      "feature_auto_assign": "Auto Assignment",
      "feature_auto_assign_desc": "Smart algorithm automatically assigns orders to the nearest available courier.",
      "feature_accounting": "Courier Accounting",
      "feature_accounting_desc": "Track courier earnings, commissions, and payments in one screen.",
      "feature_reporting": "Advanced Reporting",
      "feature_reporting_desc": "Analyze your operations with detailed analytics and visual reports.",
      "feature_restaurant_panel": "Easy Restaurant Panel",
      "feature_restaurant_panel_desc": "Simple and user-friendly order management panel for restaurants.",
      "feature_live_tracking": "Live Tracking",
      "feature_live_tracking_desc": "Track orders and couriers in real-time on the map.",
      "feature_247": "24/7 Operations",
      "feature_247_desc": "Uninterrupted service for day and night delivery management.",
      
      // Integrations
      "integrations_title": "Integrations",
      "integrations_subtitle": "Seamless integration with popular platforms",
      
      // Models
      "models_title": "Working Models",
      "models_subtitle": "Choose the model that fits your needs",
      "model_pool": "Pool Model",
      "model_pool_desc": "Pay per package, no fixed fee. Nearest available courier is auto-assigned.",
      "model_pool_feature1": "Pay per package",
      "model_pool_feature2": "No fixed fee",
      "model_pool_feature3": "Nearest courier assignment",
      "model_pool_feature4": "Flexible usage",
      "model_fixed": "Fixed Model",
      "model_fixed_desc": "Dedicated courier for your restaurant, fixed monthly fee. Full control is yours.",
      "model_fixed_feature1": "Dedicated courier",
      "model_fixed_feature2": "Fixed monthly fee",
      "model_fixed_feature3": "Priority delivery",
      "model_fixed_feature4": "Brand consistency",
      
      // Benefits
      "benefits_title": "Benefits",
      "benefits_subtitle": "Custom solutions for everyone",
      "tab_restaurant": "Restaurants",
      "tab_courier": "Couriers",
      "tab_company": "Courier Companies",
      "tab_individual": "Individual",
      
      "benefit_restaurant_1": "Fast and reliable delivery",
      "benefit_restaurant_2": "Manage all orders from one panel",
      "benefit_restaurant_3": "Transparent reporting",
      "benefit_restaurant_4": "Legal assurance",
      "benefit_restaurant_5": "Live courier tracking",
      
      "benefit_courier_1": "High earning potential",
      "benefit_courier_2": "Performance bonuses",
      "benefit_courier_3": "Flexible shift selection",
      "benefit_courier_4": "KM support",
      "benefit_courier_5": "Daily payment option",
      
      "benefit_company_1": "Automatic order assignment",
      "benefit_company_2": "Mobile courier app",
      "benefit_company_3": "Integrated accounting",
      "benefit_company_4": "Shift management",
      "benefit_company_5": "SMS/WhatsApp notifications",
      
      "benefit_individual_1": "Coming soon: Call a courier",
      "benefit_individual_2": "Fast delivery",
      "benefit_individual_3": "Live tracking",
      "benefit_individual_4": "Secure payment",
      
      // References
      "references_title": "Our References",
      "references_subtitle": "Our trusted partners",
      
      // Application Forms
      "apply_title": "Apply",
      "apply_subtitle": "Join us",
      "form_courier": "Courier Application",
      "form_restaurant": "Restaurant Application",
      "form_company": "Courier Company Application",
      
      // Courier Form
      "full_name": "Full Name",
      "phone": "Phone",
      "province": "Province",
      "district": "District",
      "license_types": "License Type",
      "has_motorcycle": "Do you have a motorcycle?",
      "motorcycle_brand": "Motorcycle Brand",
      "motorcycle_model": "Motorcycle Model",
      "daily_hours": "Daily Working Hours",
      "experience": "Experience",
      "description": "Description",
      
      // Restaurant Form
      "restaurant_name": "Restaurant Name",
      "contact_name": "Contact Name",
      "address": "Address",
      "package_count": "Daily Package Count",
      "has_courier": "Do you have your own courier?",
      "uses_other_service": "Do you use another courier service?",
      
      // Company Form
      "has_active_company": "Do you have an active courier company?",
      "application_type": "Application Type",
      "franchise_software": "Franchise + Software",
      "software_only": "Software Only",
      
      // Common
      "yes": "Yes",
      "no": "No",
      "select": "Select",
      "submit": "Submit",
      "submitting": "Submitting...",
      "success": "Success",
      "error": "Error",
      "required": "Required field",
      "captcha_label": "Security Question",
      "captcha_placeholder": "Enter answer",
      
      // Contact
      "contact_title": "Contact",
      "contact_address": "Bahçelievler mh. 3034 sk. No:5 Isparta/Center",
      
      // Footer
      "footer_slogan": "Moving Forward...",
      "footer_rights": "All rights reserved.",
      
      // Time options
      "hours_4_6": "4-6 hours",
      "hours_6_10": "6-10 hours",
      "hours_10_12": "10-12 hours",
      "hours_12_plus": "12+ hours",
      
      // Success messages
      "application_success": "Application submitted successfully!",
      "application_success_desc": "We will contact you as soon as possible.",
      
      // Restaurant Audience
      "restaurant_hero_title": "Speed Up Your Deliveries,\nDelight Your Customers",
      "restaurant_hero_subtitle": "With our professional courier network, your packages reach your customers in minutes. One panel, unlimited deliveries.",
      "restaurant_hero_cta": "Apply Now",
      "restaurant_stat_partners": "Partner Restaurants",
      "restaurant_stat_satisfaction": "Satisfaction Rate",
      "restaurant_stat_fee": "Fixed Fee",
      "restaurant_feature1_title": "All Orders on One Screen",
      "restaurant_feature1_desc": "Yemeksepeti, Getir, Trendyol... Manage orders from all platforms in one screen.",
      "restaurant_feature2_title": "Fast Courier Finding",
      "restaurant_feature2_desc": "Find the nearest available courier in seconds when your order is ready.",
      "restaurant_feature3_title": "Live Courier Tracking",
      "restaurant_feature3_desc": "Track where your orders are in real-time on the map.",
      "restaurant_feature4_title": "Easy Menu & Order Management",
      "restaurant_feature4_desc": "Easily update your menu, quickly approve and manage orders.",
      "restaurant_feature5_title": "Clear and Understandable Reports",
      "restaurant_feature5_desc": "Access your daily, weekly, and monthly delivery reports instantly.",
      "restaurant_feature6_title": "Flexible Payment Model",
      "restaurant_feature6_desc": "No fixed fee! Pay only for the deliveries you make.",
      "restaurant_benefit1": "Legal, professional, registered couriers",
      "restaurant_benefit2": "Live customer notifications",
      "restaurant_benefit3": "No setup fee, start immediately",
      "restaurant_benefit4": "Delivery matching your brand image",
      "restaurant_benefit5": "24/7 instant fast communication",
      
      // Courier Audience
      "courier_hero_title": "Set Your Own Hours,\nMultiply Your Earnings",
      "courier_hero_subtitle": "Turkey's highest-paying courier platform. Flexible shifts, daily payments, performance bonuses.",
      "courier_hero_cta": "Become a Courier",
      "courier_stat_daily": "Daily Earnings",
      "courier_stat_km": "KM Support",
      "courier_stat_bonus": "Bonus Opportunities",
      "courier_stat_bonus_value": "Special Day",
      "courier_feature1_title": "All Orders in One App",
      "courier_feature1_desc": "Easily receive and manage all orders from different restaurants through a single app.",
      "courier_feature2_title": "High Earnings",
      "courier_feature2_desc": "Maximize your earnings with the region's highest per-package rates and extra bonuses.",
      "courier_feature3_title": "Smart Route",
      "courier_feature3_desc": "The shortest and fastest delivery route is automatically determined, saving you time.",
      "courier_feature4_title": "Daily Payment & Instant Earnings Tracking",
      "courier_feature4_desc": "Track your earnings instantly, see them in your account every day. No more waiting.",
      "courier_feature5_title": "Flexible Work",
      "courier_feature5_desc": "Morning, noon, evening... Choose your shift and work as much as you want.",
      "courier_feature6_title": "Simple and Fast Usage",
      "courier_feature6_desc": "No complicated menus. Pick up, deliver, earn. It's that simple.",
      "courier_benefit1": "Performance-based bonus system",
      "courier_benefit2": "Per-km fuel support",
      "courier_benefit3": "Free Shopping from JetPuanMarket",
      "courier_benefit4": "Professional team and field support",
      "courier_benefit5": "Weekly training and development",
      
      // Company Audience
      "company_hero_title": "Bring Your Courier Operations\nInto the Digital Age",
      "company_hero_subtitle": "Turkey's most advanced courier management software. Auto-assignment, smart routing, integrated accounting.",
      "company_hero_cta": "Request Demo",
      "company_stat_efficiency": "Efficiency Increase",
      "company_stat_assignment": "Faster Assignment",
      "company_stat_setup": "Setup Fee",
      "company_feature1_title": "All Orders in One Panel",
      "company_feature1_desc": "Track and manage all orders from different sources through a single panel.",
      "company_feature2_title": "Auto Courier Assignment",
      "company_feature2_desc": "AI-powered algorithm automatically assigns to the nearest and most suitable courier.",
      "company_feature3_title": "Live Courier Tracking",
      "company_feature3_desc": "Monitor all your couriers in real-time on the map, analyze their performance.",
      "company_feature4_title": "Smart Route Optimization",
      "company_feature4_desc": "Automatically create the most efficient delivery routes with traffic and distance analysis.",
      "company_feature5_title": "Easy Accounting & Reporting",
      "company_feature5_desc": "Earnings, bonuses, deductions and detailed operation reports in one system.",
      "company_feature6_title": "Courier Performance Tracking",
      "company_feature6_desc": "Analyze each courier's delivery time, customer satisfaction and efficiency with detailed metrics.",
      "company_benefit1": "Unlimited couriers and orders",
      "company_benefit2": "Easy-to-use mobile app",
      "company_benefit3": "SMS and WhatsApp integrations",
      "company_benefit4": "Easy courier invoice management",
      "company_benefit5": "Uninterrupted service guarantee",
      
      // General Audience
      "general_hero_title": "Advance Your\nDelivery Operations",
      "general_hero_subtitle": "Courier management, auto-assignment, integrations, and powerful reporting in one platform.",
      "general_hero_cta": "Apply Now",
      "general_stat_deliveries": "Deliveries",
      "general_stat_couriers": "Couriers",
      "general_stat_restaurants": "Restaurants",
      "general_feature1_title": "Auto Assignment",
      "general_feature1_desc": "Smart algorithm automatically assigns orders to the nearest courier.",
      "general_feature2_title": "Live Tracking",
      "general_feature2_desc": "Track orders and couriers in real-time on the map.",
      "general_feature3_title": "Advanced Reporting",
      "general_feature3_desc": "Optimize your operations with detailed analytics and visual reports.",
      "general_feature4_title": "24/7 Operations",
      "general_feature4_desc": "Uninterrupted service for day and night delivery management.",
      "general_benefit1": "Fast and reliable delivery",
      "general_benefit2": "Transparent reporting",
      "general_benefit3": "Flexible payment models",
      "general_benefit4": "Integrated order management",
      "general_benefit5": "24/7 support",
      
      // Section titles
      "why_agrosjet": "Why AgrosJet?",
      "features_for_you": "Make a difference with solutions tailored for you",
      "get_started": "Get Started",
      "join_family": "Join the AgrosJet family and take your delivery operations to the next level.",
      "your_benefits": "Benefits",
      "benefits_for_you": "Custom For You",
      "benefits_subtitle": "Benefit from features that make a difference with AgrosJet and take your operations to the next level.",
      "integrations_work": "Work Seamlessly with Popular Platforms",
      "references_trusted": "Our Trusted Partners",
      "references_leading": "Leading businesses in 2 cities choose AgrosJet",
      "active_location": "Active in 2 Cities",
      "system_login": "System Login",
      
      // Models Section
      "models_badge": "Working Models",
      "models_title": "Choose the Right Model for You",
      "models_subtitle": "Flexible working models according to your business needs",
      "model_pool_title": "Pool Courier",
      "model_pool_desc": "Instant assignment from shared courier pool",
      "model_pool_f1": "Flexibility during peak hours",
      "model_pool_f2": "No fixed costs",
      "model_pool_f3": "Scale according to demand",
      "model_pool_f4": "Instant courier access",
      "model_pool_highlight": "Ideal for small and medium businesses",
      "model_fixed_title": "Dedicated Courier",
      "model_fixed_desc": "Dedicated courier team assigned to you",
      "model_fixed_f1": "Couriers who know your customers",
      "model_fixed_f2": "Consistent service quality",
      "model_fixed_f3": "Priority delivery",
      "model_fixed_f4": "Team representing your brand",
      "model_fixed_highlight": "Ideal for high-volume businesses",

      // Why AgrosJet Section
      "why_agros_title": "Why",
      "why_agros_point1": "Over 3 years of uninterrupted field operations experience",
      "why_agros_point2": "End-to-end digital solution for courier management",
      "why_agros_point3": "Growing partner network across Turkey",
      "why_agros_point4": "Continuously updated, evolving technology infrastructure",
      "why_agros_desc1": "AgrosJet has been running uninterrupted field operations for over 3 years. We are not just a technology company developing software; we are a team that manages operations in the field every day. Our software was not born at a desk, but from real delivery processes.",
      "why_agros_desc2": "That's why every feature we offer is a direct reflection of your operational needs. We provide the most ambitious solution in the industry for operational reliability, speed, and customer satisfaction.",

      // Pricing Section
      "pricing_badge": "Pricing",
      "pricing_title": "Choose the Right Plan for You",
      "pricing_subtitle": "Flexible pricing options based on your operation volume",
      "pricing_popular": "Popular",
      "pricing_starter_name": "Pay-Per-Use",
      "pricing_starter_subtitle": "Per package pricing",
      "pricing_starter_price": "Per Package",
      "pricing_starter_note": "Unit price decreases as volume increases",
      "pricing_starter_f1": "Fixed price per package",
      "pricing_starter_f2": "Discounted price at high volume",
      "pricing_starter_f3": "No setup fee",
      "pricing_starter_f4": "Basic reporting",
      "pricing_starter_f5": "Email support",
      "pricing_starter_cta": "Get Quote",
      "pricing_pro_name": "Fixed",
      "pricing_pro_subtitle": "Monthly fixed pricing",
      "pricing_pro_price": "Monthly Fixed",
      "pricing_pro_note": "Unlimited packages, predictable budget",
      "pricing_pro_f1": "Unlimited package quota",
      "pricing_pro_f2": "Advanced reporting and analytics",
      "pricing_pro_f3": "Priority technical support",
      "pricing_pro_f4": "Integration support",
      "pricing_pro_f5": "Dedicated account manager",
      "pricing_pro_cta": "Get Quote",
      "pricing_franchise_name": "Franchise",
      "pricing_franchise_subtitle": "Become an AgrosJet franchisee",
      "pricing_franchise_price": "Custom Quote",
      "pricing_franchise_note": "Custom pricing for your business",
      "pricing_franchise_f1": "All software features",
      "pricing_franchise_f2": "Regional exclusivity",
      "pricing_franchise_f3": "Brand and operations support",
      "pricing_franchise_f4": "Training and consulting",
      "pricing_franchise_f5": "Revenue sharing model",
      "pricing_franchise_cta": "Get Custom Quote",

      // === Landing v2 (Unified Neon) ===
      "v2_nav_features": "Features",
      "v2_nav_integrations": "Integrations",
      "v2_nav_references": "References",
      "v2_nav_contact": "Contact",
      "v2_apply_dropdown": "Applications",
      "v2_apply_courier": "Courier Application",
      "v2_apply_restaurant": "Restaurant Application",
      "v2_apply_company": "Courier Company Application",
      "v2_hero_badge": "AgrosJet · Delivery Operations Platform",
      "v2_hero_title_line1": "Build the",
      "v2_hero_title_line2": "Future of",
      "v2_hero_title_line3": "Delivery Today.",
      "v2_hero_sub": "An end-to-end platform for restaurants, couriers, and courier companies. Auto-assignment, smart routing, weekly payouts, and real-time analytics — all in one.",
      "v2_hero_cta": "Applications",
      "v2_hero_scroll": "Scroll down",
      "v2_audience_title": "Who are you? Start with one click.",
      "v2_audience_sub": "Whichever side you're on, AgrosJet is ready to work with you.",
      "v2_audience_restaurant_title": "I'm a Restaurant",
      "v2_audience_restaurant_desc": "Centralize orders from every platform on one panel and deliver in minutes with professional couriers.",
      "v2_audience_restaurant_cta": "Restaurant Application",
      "v2_audience_courier_title": "I'm a Courier",
      "v2_audience_courier_desc": "Work flexible shifts, get paid weekly. Multiply your earnings with smart routing and performance bonuses.",
      "v2_audience_courier_cta": "Courier Application",
      "v2_audience_company_title": "I'm a Courier Company",
      "v2_audience_company_desc": "Digitize your operations. Auto-assignment, live tracking, integrated accounting, and unlimited scaling.",
      "v2_audience_company_cta": "Company Application",
      "v2_stats_title": "AgrosJet in Numbers",
      "v2_stats_deliveries": "Total Deliveries",
      "v2_stats_couriers": "Active Couriers",
      "v2_stats_restaurants": "Partner Restaurants",
      "v2_stats_years": "Years in the Field",
      "v2_features_badge": "Platform Features",
      "v2_features_title": "One platform.",
      "v2_features_title_accent": "Endless possibilities.",
      "v2_features_sub": "Powerful modules designed for every stage of the operation.",
      "v2_feature1_title": "Auto Assignment",
      "v2_feature1_desc": "AI-powered algorithm assigns the order to the nearest, best-fit courier in seconds.",
      "v2_feature2_title": "Live Map Tracking",
      "v2_feature2_desc": "Watch all couriers and orders in real time, send live notifications to your customers.",
      "v2_feature3_title": "Smart Routing",
      "v2_feature3_desc": "The fastest delivery route is built automatically using traffic and distance analysis.",
      "v2_feature4_title": "Weekly Payout",
      "v2_feature4_desc": "Regular weekly payouts for couriers; funds land in the account within 30 minutes of the payout request.",
      "v2_feature5_title": "Unified Panel",
      "v2_feature5_desc": "Orders from Yemeksepeti, Getir, Trendyol and other platforms on a single screen.",
      "v2_feature6_title": "Performance Analytics",
      "v2_feature6_desc": "Courier time, customer satisfaction, order volume — every metric in visual reports.",
      "v2_feature7_title": "API & Integrations",
      "v2_feature7_desc": "Open API and ready integrations that work seamlessly with your existing systems.",
      "v2_feature8_title": "24/7 Operations",
      "v2_feature8_desc": "Our field team and technical support is with you every day, every hour.",
      "v2_why_badge": "Why AgrosJet?",
      "v2_why_title": "Not built at a desk —",
      "v2_why_title_accent": "born in the field.",
      "v2_why_desc1": "AgrosJet is built by a team that has run uninterrupted field operations for over 3 years. Our software is tested every day with real couriers, real restaurants and real customers.",
      "v2_why_desc2": "That's why every feature we ship is an answer to the industry's real needs. Not guesswork — experience.",
      "v2_why_point1": "3+ years of uninterrupted field operations",
      "v2_why_point2": "End-to-end digital courier management",
      "v2_why_point3": "Growing partner network across Turkey",
      "v2_why_point4": "Continuously updated technology stack",
      "v2_cta_title": "Ready?",
      "v2_cta_title_accent": "Take a step. Let AgrosJet move you forward.",
      "v2_cta_sub": "Pick the application form that fits you and our team will get back within 24 hours.",
      "v2_cta_button": "Applications",
      "v2_footer_tagline": "Moves your delivery operations forward."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr',
    fallbackLng: 'tr',
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
